import React from "react";
import { url } from "../Functionalities/Config";
import image from "../Assets/images/profile_icon.jpg";

function CommentListingComponent({ review, user }) {
  // void 0

  // const rateditems = [];


  //shabeeb change start
  let rateditems = []
  //shabeeb change ends

  const rate = review.rating && review.rating.length > 0 && review.rating[0].rating.toFixed(0);
  for (let i = 0; i < rate; i++) {
    rateditems.push(<i className="fa fa-star text-primary" />);
  }


  // const notrateditems = [];
  // for (let i = 0; i < 5 - rate; i++) {
  //   notrateditems.push(<i className="fa fa-star text-gray" />);
  // }

  return (
    <div className="media review-box">
      {review.voter.images != null ? (
        <img
          className="mr-3 img-fluid btn-rounded"
          width={55}
          height={55}
          src={url + review.voter.images.image}
          alt="Foodoor"
        />
      ) : (
        <img
          className="mr-3 img-fluid btn-rounded"
          width={55}
          height={55}
          src={image}
          alt="Foodoor"
        />
      )}
      <div className="media-body">
        <h4 className="mt-0 mb-0 text-black">{review.voter.first_name}</h4>
        <ul className="review-meta mb-3 d-block d-sm-flex align-items-center">
          <li className="mr-3">
            <small>{new Date(review.review_time).toDateString()}</small>
          </li>
          <li className="mr-3">
            <small>Restaurant : {review.branch_name}</small>
          </li>
          <li className="mr-3">
            <small>Product : {review.item_name}</small>
          </li>
        </ul>

        <p className="mb-3 text-secondary">{review.review}</p>
      </div>

      <div className="media-footer align-self-center">
        <div className="star-review text-md-center">
          {typeof review.rating != "undefined" &&
            review.rating != null &&
            review.rating.length != null &&
            review.rating.length > 0 ? (
            <div class="star-review2 d-flex align-items-center flex-wrap fs-12 mt-2 ml-5">
              <div class="mb-4">
                <i class="fa fa-star text-primary">
                  &nbsp;
                  {review.rating[0].rating.toFixed(1)}
                </i>
              </div>
            </div>
          ) : (
            <div class="star-review2 d-flex align-items-center flex-wrap fs-12 mt-2 ml-5">
              <div class="mb-4">
                <i class="fa fa-star text-primary">&nbsp; 0</i>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CommentListingComponent;
